import { Injectable } from '@angular/core';
import {
  IssuePlatformParkingCardPayload,
  PlatformCardListRow,
  PlatformCardTableDto,
  RevokePlatformParkingCardPayload,
} from '../../models/card-quota/platform-card.model';
import { SaveAdminParkingMemberPayload } from '../../models/parking/parking-card-list.model';

@Injectable({ providedIn: 'root' })
export class MapperPlatformCardService {
  mapTable(dto: PlatformCardTableDto): {
    items: PlatformCardListRow[];
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
  } {
    const raw = dto as PlatformCardTableDto & Record<string, unknown>;
    const rows = (dto.data ?? raw['Data'] ?? []) as PlatformCardListRow[];
    return {
      items: rows.map((r) => this.mapListRow(r as PlatformCardListRow & Record<string, unknown>)),
      total: Number(dto.total ?? raw['Total'] ?? 0),
      page: Number(dto.page ?? raw['Page'] ?? 1),
      pageSize: Number(dto.pageSize ?? raw['PageSize'] ?? 20),
      totalPages: Number(dto.totalPages ?? raw['TotalPages'] ?? 0),
    };
  }

  mapListRow(row: PlatformCardListRow & Record<string, unknown>): PlatformCardListRow {
    return {
      id: Number(row.id ?? row['Id'] ?? 0),
      cardName: String(row.cardName ?? row['CardName'] ?? ''),
      name: String(row.name ?? row['Name'] ?? ''),
      telephone: row.telephone != null ? String(row.telephone ?? row['Telephone']) : null,
      clientId: Number(row.clientId ?? row['ClientId'] ?? 0),
      clientName: String(row.clientName ?? row['ClientName'] ?? ''),
      siteId: Number(row.siteId ?? row['SiteId'] ?? 0),
      cardTypeId: Number(row.cardTypeId ?? row['CardTypeId'] ?? 0),
      cardTypeName: String(row.cardTypeName ?? row['CardTypeName'] ?? ''),
      quotaId: row.quotaId != null ? Number(row.quotaId ?? row['QuotaId']) : null,
      quotaStatus: String(row.quotaStatus ?? row['QuotaStatus'] ?? ''),
      platformCardStatus: String(row.platformCardStatus ?? row['PlatformCardStatus'] ?? ''),
      issueDate: row.issueDate != null ? String(row.issueDate ?? row['IssueDate']) : null,
      expireDate: row.expireDate != null ? String(row.expireDate ?? row['ExpireDate']) : null,
      createDate: row.createDate != null ? String(row.createDate ?? row['CreateDate']) : null,
    };
  }

  statusLabel(status: string): string {
    const map: Record<string, string> = {
      active: 'ใช้งาน',
      not_ready: 'ระงับ',
      revoked: 'ยกเลิกแล้ว',
    };
    return map[status] ?? status;
  }

  buildIssuePayload(
    member: SaveAdminParkingMemberPayload,
    menuId: number,
    quotaId?: number | null
  ): IssuePlatformParkingCardPayload {
    return { ...member, menuId, quotaId: quotaId ?? null };
  }

  buildRevokePayload(cardId: number, userId: number, menuId: number): RevokePlatformParkingCardPayload {
    return { cardId, userId, menuId };
  }
}
